import React from "react";


export default function SubmitButton({ loading, loadingText, additionnalClass, className, children, ...rest }) {
    const isLoading = loading === "true" || loading === true

    const base = additionnalClass
        ? "btn btn-primary btn-user btn-block " + additionnalClass
        : "btn btn-primary btn-user btn-block"
    const classes = className || base

    if (isLoading) {
        return (
            <button className={classes + " btn-loading"} type="submit" disabled {...rest}>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                <span>{loadingText || "Chargement…"}</span>
            </button>
        )
    }

    return (
        <button className={classes} type="submit" {...rest}>
            {children}
        </button>
    )
}
